// @mui
import {
  TableRow,
  TableCell,
  Typography,
  Button,
  Stack,
  Grid,
  Card,
  CardHeader,
  Divider,
  Table,
  TableBody,
  TableContainer,
  Box,
} from '@mui/material';
import Iconify from 'src/components/Iconify';
import { PATH_DASHBOARD } from 'src/routes/paths';
// @types

import { useNavigate } from 'react-router-dom';

import Scrollbar from 'src/components/Scrollbar';
import { TableHeadCustom } from 'src/components/table';
//Localization
import useLocales from 'src/hooks/useLocales';
import { ElectricBoxDetails, IElectricBox } from 'src/@types/Choqorak/Settings/ElectricBox';

type Props = {
  row: ElectricBoxDetails;
  clearElectricBox: () => void;
};

export default function ElectricBoxDetailTableRow({ row, clearElectricBox }: Props) {
  const { translate } = useLocales(); //Localization
  const navigate = useNavigate();

  const ELECTRIC_METER_HEAD = [
    { id: 'no', label: `${translate('GeneralFields.No')}`, align: 'left' },
    { id: 'serial', label: `${translate('ElectricMeter.ElectricMeterSerial')}`, align: 'left' },
    { id: 'price', label: `${translate('ElectricMeter.ElectricityPrice')}`, align: 'left' },
  ];

  return (
    <>
      {/* Electric Box Info */}
      <Grid item xs={12}>
        <Card
          sx={{
            p: 3,
            mb: 3,
            backgroundColor: 'grey.800',
            color: 'grey.100',
            borderRadius: 2,
            boxShadow: 3,
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {/* Electric Box Info */}
            <Box sx={{ flex: 1 }}>
              <Typography variant="h5" sx={{ mb: 1, fontWeight: 'bold' }}>
                {translate('ElectricBox.ElectricBox')}
              </Typography>

              <Table size="small" sx={{ width: 'auto' }}>
                <TableBody>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold' }}>
                      {translate('ElectricBox.ElectricBoxCode')}
                    </TableCell>
                    <TableCell>{row.electricBoxCode}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold' }}>
                      {translate('ElectricBox.Description')}
                    </TableCell>
                    <TableCell>{row.description}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Box>

            {/* Electric Box Image */}
            <Box sx={{ flexShrink: 0, ml: 2 }}>
              <img
                src="/Images/electricbox.webp" // Replace with the actual path to the image
                alt={translate('electricBoxDetail.imageAlt')}
                style={{
                  width: '150px',
                  height: '150px',
                  borderRadius: '8px',
                  objectFit: 'cover',
                }}
              />
            </Box>
          </Box>
        </Card>
      </Grid>

      {/* Electric Meters Table */}
      <Grid item xs={12}>
        <Card sx={{ borderRadius: 2, boxShadow: 3 }}>
          <Typography variant="h6" sx={{ p: 2, fontWeight: 'bold' }}>
            {translate('ElectricMeter.ElectricMeter')}
          </Typography>
          <Scrollbar>
            <TableContainer sx={{ minWidth: 720 }}>
              <Table>
                <TableHeadCustom headLabel={ELECTRIC_METER_HEAD} />
                <TableBody>
                  {row.electricMeters.length > 0 ? (
                    row.electricMeters.map((meter, index) => (
                      <TableRow key={meter.electricMeterId}>
                        <TableCell align="left" sx={{ padding: '8px' }}>
                          {index + 1}
                        </TableCell>
                        <TableCell align="left">{meter.electricMeterSerial}</TableCell>
                        <TableCell align="left">{meter.pricePerKilowat}</TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell align="center" colSpan={ELECTRIC_METER_HEAD.length}>
                        {translate('electricBoxDetail.noMeters')}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Scrollbar>
          <Divider sx={{ borderColor: 'grey.700' }} />
        </Card>
      </Grid>
    </>
  );
}
